export default [
    {
        path: 'relatorio-movimentacao-geral',
        component: () => import(/* webpackChunkName: 'almoxarifado-relatorio-movimentacao-geral' */ '@/views/almoxarifado/relatorio-movimentacao-geral/Index'),
        redirect: 'relatorio-movimentacao-geral/index',
        children: [
            {
                name: 'almoxarifado-relatorio-movimentacao-geral-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'almoxarifado-relatorio-movimentacao-geral' */ '@/views/almoxarifado/relatorio-movimentacao-geral/List.vue'),
            },
        ],
    },
]